/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonPrimary } from '@/components/button'
import { ArrowBack, UserIconFilled } from '@/components/icons'
import { Loading } from '@/components/loading'
import { ConfirmModal } from '@/components/modal'
import { ROUTE_DASHBOARD, ROUTE_SIGNUP } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import { useDuprIdDetails } from '@/services/user'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

export const ClaimDetail = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const { token } = useAppSelector(authSelector)
  const { claimId } = useParams()

  useEffect(() => {
    if (token) {
      navigate(ROUTE_DASHBOARD, { relative: 'path', replace: true })
    }
  }, [token])

  const duprIdDetails = useDuprIdDetails(claimId || '')

  const [isOpen, setIsOpen] = useState(false)

  const onGoBack = () => navigate(-1)

  const closeConfirmModal = () => setIsOpen(false)

  if (duprIdDetails.error) {
    return <ErrorOccurred error={duprIdDetails.error} />
  }
  if (!duprIdDetails.data) {
    return <Loading />
  }

  const { name, age, gender, userId } = duprIdDetails.data.results[0]

  const handleClaimAccount = () => {
    navigate(ROUTE_SIGNUP, {
      state: {
        playerId: userId,
      },
    })
  }

  return duprIdDetails.isLoading ? (
    <Loading />
  ) : (
    <>
      <div className="w-screen relative h-screen pt-4 sm:pt-24 overflow-hidden flex justify-center">
        <div className="w-full px-4 sm:pl-14 sm:pr-1 sm:w-[500px] md:w-[560px] lg:w-[680px] flex flex-col gap-y-10 pb-4 overflow-y-auto">
          <div className="flex relative flex-col gap-y-4 sm:flex-row sm:items-center mt-8 sm:mt-0">
            <Button onClick={onGoBack} className="hover:opacity-50 flex sm:absolute sm:-left-12 sm:top-1">
              <ArrowBack className="text-white" />
            </Button>
            <div className="flex flex-col gap-y-[10px]">
              <h1 className="text-2xl xs:text-3xl font-bold text-white">{t('auth.claimAccount')}</h1>
              <p className="text-sm text-white">{t('auth.claimAccountDesc')}</p>
            </div>
          </div>

          <div className="flex flex-col gap-y-6">
            <div className="flex flex-row gap-x-2">
              <UserIconFilled className="w-14 h-14 text-white" />

              <div className="flex flex-col">
                <span className="font-bold text-2xl text-white">{name}</span>
                <span className="text-white text-opacity-50 text-sm">
                  {gender ? t(`player.${gender}`) : 'Gender: NA'} • {age || 'Age: NA'}
                </span>
              </div>
            </div>
            <ButtonPrimary title="This Is Me" className="w-full" onClick={handleClaimAccount} />
          </div>
        </div>
      </div>
      <ConfirmModal
        open={isOpen}
        onClose={closeConfirmModal}
        title={t('auth.accAlreadyTaken')}
        desc={t('auth.accAlreadyTakenModal')}
        disableCancelBtn
        submitTitle={t('common.contactSupport')}
        onSubmit={() =>
          window.open('https://dupr.zendesk.com/hc/en-us/requests/new?ticket_form_id=26010354856852', '_blank')
        }
      />
    </>
  )
}

function ErrorOccurred({ error }: { error: unknown }) {
  return (
    <div className="w-screen relative h-screen pt-4 sm:pt-24 overflow-hidden flex justify-center">
      <div className="w-full px-4 sm:pl-14 sm:pr-1 sm:w-[500px] md:w-[560px] lg:w-[680px] flex flex-col gap-y-10 pb-4 overflow-y-auto">
        <div className="flex relative flex-col gap-y-4 sm:flex-row sm:items-center mt-8 sm:mt-0">
          <h2 className="text-lg font-bold text-white">{error instanceof Error ? error.message : String(error)}</h2>
        </div>
      </div>
    </div>
  )
}
